import gql from "graphql-tag";
import LocalBookFragments from './LocalBookFragments';

export default {
  updateLocalBook: gql`
    mutation updateLocalBook($input: updateLocalBookInput!) {
      updateLocalBook(input: $input) {
        localBook {
          ...LocalBookDetails
        }
      }
    }
    ${LocalBookFragments.localBookDetailsFragment}
  `,
  
  createLocalBook: gql`
    mutation createLocalBook($input: createLocalBookInput!) {
      createLocalBook(input: $input) {
        localBook {
          ...LocalBookDetails
        }
      }
    }
    ${LocalBookFragments.localBookDetailsFragment}
  `,

  deleteLocalBook: gql`
    mutation deleteLocalBook($id: ID!) {
      deleteLocalBook(input: { id: $id }) {
        localBook {
          id
        }
      }
    }
  `
};
